import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__image_asset_category } from '../../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../../../_base/ENUM__invocation_type';
import { INVOCATION_VISION__base_cv2 } from '../../_base/INVOCATION_VISION__base_cv2';

export class INVOCATION_VISION_CV2__control_line_guidance_canny_auto extends INVOCATION_VISION__base_cv2 {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_CV2__LINE__CANNY_AUTO;

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input_transform_none({ category: ENUM__image_asset_category.IMAGE }, { field_role: '🖼️ Image' })
  image!: FIELD__image_asset;

  /*
   * OUTPUT
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.LINE__CANNY })
  out!: FIELD__image_asset;

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_CV2__LINE__CANNY_AUTO);
  }
}
